import { Slide } from "@mui/material";
import React from "react";
import { twMerge } from "tailwind-merge";

const SlideTransition = ({ appear, className, children, timeout }) => {
  return (
    <div className={twMerge("overflow-hidden", className)}>
      <Slide
        direction="up"
        in={appear}
        mountOnEnter
        timeout={timeout}
        unmountOnExit
      >
        {children}
      </Slide>
    </div>
  );
};

export default SlideTransition;
